/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Quota_Notice_Exhausted_MonthInputs */

const fr_calendar_quota_notice_exhausted_month = /** @type {(inputs: Calendar_Quota_Notice_Exhausted_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous tes cours du mois sont utilisés : tu peux seulement t'inscrire à un cours d'une journée déjà entamée.`)
};

/**

* @param {Calendar_Quota_Notice_Exhausted_MonthInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_notice_exhausted_month = /** @type {((inputs?: Calendar_Quota_Notice_Exhausted_MonthInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Notice_Exhausted_MonthInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_notice_exhausted_month(inputs)
});